import { NavLink, Outlet } from 'react-router-dom';
import { useSession } from '../lib/session';
import { FeedbackPopup } from './FeedbackPopup';
import { Brand } from './Brand';
import { ImpersonationBanner } from './ImpersonationBanner';
import { CompleteWinningPayment } from './CompleteWinningPayment';
import './AppShell.css';

export function AppShell() {
  const { profile } = useSession();

  return (
    <div className="shell">
      <ImpersonationBanner />
      <CompleteWinningPayment />

      <nav className="shell__nav" aria-label="Primary">
        <div className="container shell__nav-inner">
          <NavLink to="/" className="shell__brand">
            <img src="/logos/cc-logo-header.png" alt="CONVERTED CLOSET" />
          </NavLink>

          <div className="shell__links">
            <NavLink to="/" end>Closets</NavLink>
            <NavLink to="/saleroom">Saleroom</NavLink>
            <NavLink to="/calendar">Calendar</NavLink>
            <NavLink to="/profile">Profile</NavLink>
            {(profile?.role === 'admin' || profile?.role === 'developer') && (
              <NavLink to="/admin">Admin</NavLink>
            )}
          </div>
        </div>
      </nav>

      <main className="shell__main">
        <Outlet />
      </main>

      <footer className="shell__footer">
        <div className="container shell__footer-inner">
          <span className="shell__footer-legal">© 2026 <Brand /></span>
          <nav className="shell__footer-nav" aria-label="Legal">
            <a className="shell__footer-link" href="/privacy">Privacy</a>
            <a className="shell__footer-link" href="/terms">Terms</a>
          </nav>
        </div>
      </footer>

      <FeedbackPopup />
    </div>
  );
}
